import { config } from "@/config/env";
import type { AppQueryConfig } from "QueryTypes";
import type { GameScorecard, ScorecardPayload } from "ScorecardModels";
import { clubhouseApiHeadersV1 } from "utils/api/apiHelper";

const urls = {
  scorecardLookup(): string {
    return `${config.apiBaseUrl}/api/scorecards`;
  },
};

export const getScorecardsBySearch = (
  facilityId: string,
  body: ScorecardPayload,
): AppQueryConfig => ({
  url: urls.scorecardLookup(),
  queryKey: `getScorecardsByFacilityId:${body.userIds?.join(",")}-${body.startDate?.toISOString()}-${body.endDate?.toISOString()}`,
  options: {
    ...clubhouseApiHeadersV1(),
    method: "POST",
  },
  body,
  transform: (responseJson: GameScorecard[]) => {
    const obj: { [id: string]: GameScorecard } = {};

    responseJson?.map((scorecard) => {
      return (obj[scorecard?.saveGameId] = scorecard);
    });

    return {
      scorecards: {
        byFacilityId: {
          [facilityId]: obj,
        },
      },
    };
  },
  update: {
    scorecards: (oldValue, newValue) => ({
      byFacilityId: {
        ...oldValue?.byFacilityId,
        ...{
          [facilityId]: {
            ...oldValue?.byFacilityId?.[facilityId],
            ...newValue.byFacilityId[facilityId],
          },
        },
      },
    }),
  },
});

export const makeDismissAllScorecardsMutation = (
  facilityId: string,
): AppQueryConfig => ({
  url: urls.scorecardLookup(),
  options: { ...clubhouseApiHeadersV1(), method: "DELETE" },
  optimisticUpdate: {
    scorecards: (oldValue) => {
      if (facilityId) delete oldValue?.byFacilityId[facilityId];
      return oldValue;
    },
  },
});
